import React from 'react';
import ConceptContainerVersionForm from '../common/ConceptContainerVersionForm';

const CollectionVersionForm = props => <ConceptContainerVersionForm {...props} resourceType="collection" />;

export default CollectionVersionForm;
